declare global {
  interface Window {
    __RUNTIME_CONFIG__?: Record<string, string>;
  }
}

function getViteOrRuntime(key: string): string | undefined {
  const envKey = `VITE_${key}`;
  const viteVal = import.meta.env[envKey];
  if (viteVal !== undefined && viteVal !== "") return viteVal as string;
  if (typeof window !== "undefined" && window.__RUNTIME_CONFIG__?.[key]) {
    return window.__RUNTIME_CONFIG__[key];
  }
  return undefined;
}

export const getCoreApiUrl = () => getViteOrRuntime("CORE_API_URL") || "http://localhost:9001";
export const getApiBaseUrl = () => getViteOrRuntime("API_BASE_URL") || "";
export const getAppVersion = () => getViteOrRuntime("APP_VERSION") || "";
export const getLogLevels = () => getViteOrRuntime("LOG_LEVELS") || "*";
export const getAppKey = () => getViteOrRuntime("APP_KEY") || "licita";

export function getAuthRedirectUri(): string {
  const configured = getViteOrRuntime("AUTH_REDIRECT_URI")?.trim();
  const fallback = typeof window !== "undefined" ? window.location.origin : "";
  const candidate = configured || fallback;
  if (!candidate) return "";
  try {
    const url = new URL(candidate);
    if (url.protocol !== "http:" && url.protocol !== "https:") return fallback;
    return url.toString().replace(/\/$/, "");
  } catch {
    return fallback;
  }
}

export function getAllowedRedirectHosts(redirectUri: string): string[] {
  const hosts = new Set(["localhost", "127.0.0.1", "dev-core.tgtone.cl", "tgtone.cl"]);
  try {
    hosts.add(new URL(redirectUri).hostname);
  } catch {
    // The URI is validated by getAuthRedirectUri; keep the safe defaults if absent.
  }
  return [...hosts];
}

export const getUseMocks = () => {
  const v = getViteOrRuntime("USE_MOCKS");
  return v === undefined || v === "" ? true : v === "true" || v === "1";
};
